import { getCountryCodeByName, payPalToIsoCode } from '@/lib/paypal-countries';

export function normalizeCountryCode(country: string): string {
  if (!country) return '';
  
  const trimmed = country.trim();
  if (!trimmed) return '';
  
  const countryUpper = trimmed.toUpperCase();
  
  if (countryUpper.length === 2 || countryUpper.length === 3) {
    const normalized = payPalToIsoCode(countryUpper);
    return normalized || countryUpper;
  }
  
  const codeFromName = getCountryCodeByName(trimmed);
  if (codeFromName && codeFromName !== trimmed) {
    const normalized = payPalToIsoCode(codeFromName);
    return normalized || codeFromName;
  }
  
  return countryUpper;
}
